import script from "./RealTimeCharts.vue?vue&type=script&setup=true&lang=js"
export * from "./RealTimeCharts.vue?vue&type=script&setup=true&lang=js"

import "./RealTimeCharts.vue?vue&type=style&index=0&id=8d6abe80&lang=css"

const __exports__ = script;

export default __exports__